const timezones = {
  "Pacific/Midway": "Pacific/Midway",
  "Pacific/Pago_Pago": "Pacific/Pago_Pago",
  "Pacific/Honolulu": "Pacific/Honolulu",
  "America/Anchorage": "America/Anchorage",
  "America/Los_Angeles": "America/Los_Angeles",
  "America/Tijuana": "America/Tijuana",
  "America/Denver": "America/Denver",
  "America/Phoenix": "America/Phoenix",
  "America/Chihuahua": "America/Chihuahua",
  "America/Chicago": "America/Chicago",
  "America/Mexico_City": "America/Mexico_City",
  "America/Guatemala": "America/Guatemala",
  "America/New_York": "America/New_York",
  "America/Bogota": "America/Bogota",
  "America/Caracas": "America/Caracas",
  "America/Santiago": "America/Santiago",
  "America/Halifax": "America/Halifax",
  "America/Montevideo": "America/Montevideo",
  "America/Sao_Paulo": "America/Sao_Paulo",
  "America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
  "America/Godthab": "America/Godthab",
  "Atlantic/South_Georgia": "Atlantic/South_Georgia",
  "Atlantic/Azores": "Atlantic/Azores",
  "Atlantic/Cape_Verde": "Atlantic/Cape_Verde",
  "Europe/London": "Europe/London",
  "UTC": "UTC",
  "Africa/Casablanca": "Africa/Casablanca",
  "Europe/Berlin": "Europe/Berlin",
  "Europe/Paris": "Europe/Paris",
  "Africa/Lagos": "Africa/Lagos",
  "Europe/Athens": "Europe/Athens",
  "Europe/Kiev": "Europe/Kiev",
  "Africa/Johannesburg": "Africa/Johannesburg",
  "Europe/Moscow": "Europe/Moscow",
  "Asia/Baghdad": "Asia/Baghdad",
  "Asia/Tehran": "Asia/Tehran",
  "Asia/Dubai": "Asia/Dubai",
  "Asia/Baku": "Asia/Baku",
  "Asia/Kabul": "Asia/Kabul",
  "Asia/Karachi": "Asia/Karachi",
  "Asia/Kolkata": "Asia/Kolkata",
  "Asia/Kathmandu": "Asia/Kathmandu",
  "Asia/Dhaka": "Asia/Dhaka",
  "Asia/Yangon": "Asia/Yangon",
  "Asia/Bangkok": "Asia/Bangkok",
  "Asia/Shanghai": "Asia/Shanghai",
  "Asia/Tokyo": "Asia/Tokyo",
  "Australia/Adelaide": "Australia/Adelaide",
  "Australia/Sydney": "Australia/Sydney",
  "Pacific/Noumea": "Pacific/Noumea",
  "Pacific/Auckland": "Pacific/Auckland",
  "Pacific/Tongatapu": "Pacific/Tongatapu"
};

export default timezones;
